export default __webpack_public_path__ + "static/media/politica_de_proteccion_de_datos_personales.e5966e99.pdf";